<div class="flex items-end gap-2">
  @if (isReloadLoading) {
    <div class="w-[2.5rem] self-center">
      <app-loader padding="0" [diameter]="'24'" height="100%"></app-loader>
    </div>
  } @else {
    <button
      mat-icon-button
      [attr.aria-label]="'reload' | translate"
      (click)="reload()"
      matTooltip="{{ 'reload' | translate }}">
      <mat-icon>refresh</mat-icon>
    </button>
  }

  @if (searchOrders?.length) {
    <div class="per-page-block">
      <mat-form-field class="w-[36px] xs:w-[56px]">
        <mat-select
          class="text-center"
          [(value)]="searchOrder"
          (valueChange)="searchOrderChange($event)">
          @for (searchOrder of searchOrders; track searchOrder.id) {
            <mat-option [value]="searchOrder.id" style="width: auto">
              {{ searchOrder.name | translate | lowercase }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (orderDirection) {
    <button
      mat-icon-button
      (click)="changeOrder()"
      matTooltip="{{ 'order' | translate }}">
      <mat-icon>{{
        orderDirection === 2 ? 'arrow_downward' : 'arrow_upwards'
      }}</mat-icon>
    </button>
  }

  <div class="flex min-w-[100px] gap-2 self-center text-center text-[14px]">
    @if (!selectedCount) {
      {{ 'total' | translate }}: {{ countTotal }}
    } @else {
      {{ 'selected' | translate }}: {{ selectedCount }}
    }
  </div>
</div>
